import React, {Component} from 'react';

import {Row, Col} from 'reactstrap';
import axios from 'axios';
import _ from 'lodash';

import {serverPath} from '../common.js';

import SubmissionList from './SubmissionListComponent.js';
import SubmissionOptionsModals from './submissionOptions/SubmissionOptionsModalsComponent.js';




class CourseRequestedSubmissions extends Component
{

	constructor(props)
	{
		super(props);

		this.state =
			{
				submissions:[], 
				user:{userId:0},
				loading:true,
				forceUpdate:false


			};

		this.onSubmissionListChange = this.onSubmissionListChange.bind(this);
		this.renderBody = this.renderBody.bind(this);
	}

	async getFromLink(link)
	{
		let response = null;
		let onRecive = (prevState)=>
				{
					return {
						submissions:prevState.submissions.concat(response.data.submissions),
						forceUpdate:!prevState.forceUpdate
					};
				};

		while(true)
		{
			response = await axios.get(link);	

			if(!response)
			{
				break;
			}
			
			this.setState(onRecive);
			if(_.has(response.data, 'next'))
			{
				link = response.data.next;
			}
			else
			{
				break;
			}

		}
		this.setState({loading:false});
	}

	getData()
	{
		axios.get(serverPath + 'professorService.php', 
			{
				params:
				{
					action:'getSubmissions',
					courseId:this.props.match.params.courseId,
					filter:'requested',
					limit:100
				}
			})
			.then((response)=>
				{
					this.setState(
						{
							submissions:response.data.submissions.map((submission)=>{
								//this is added so that only submissions with review requests for this professor are
								// colored in red in SubmissionListComponent(line 171, or somewhere near)
								submission.hasReviewForLoggedProfessor = submission.reviewer !== null
									&& submission.reviewer === this.state.user.userId;
								return submission;
							}),
							forceUpdate:!this.state.forceUpdate
						});
					if(_.has(response.data, 'next'))
					{
						this.getFromLink(response.data.next);
					}
					else
					{
						this.setState({loading:false});
					}
				});
	}

	/**
	 * @description Use this function to auth user
	 **/
	componentDidMount()
	{
		axios.get(serverPath + "authService.php", {params:{action: 'whoIsLoggedIn'}})
			.then((response) =>
				{

					if(response.data !== null && response.data.roleName === "professor")
					{
						this.setState({user:response.data})
						this.getData();
					}
					else
					{
						this.props.history.push('/home');
					}
				});
	}
	
	onSubmissionListChange(submissionId, codeReview)
	{
		const index = this.state.submissions.findIndex((el)=>
			{

				return el.idProblemSubmission === submissionId;
			});

		this.setState((prevState)=>
			{
				var prev = prevState.submissions.slice(0, index);
				var next = prevState.submissions.slice(index+1);
				var curr = prevState.submissions[index];
				curr = {...curr, codeReview:codeReview, anwsered:true};
				return {
					submissions: prev.concat([curr], next),
					forceUpdate:!this.state.forceUpdate

				};
			});
	}

	renderBody(callbacks)
	{
		return (
			<React.Fragment>
				<Row>
					<Col>
						<SubmissionList submissions={this.state.submissions} {...callbacks}
							forceUpdate={this.state.forceUpdate}
						/>
					</Col>
				</Row>
			</React.Fragment>
		);
	}

	render()
	{
		return (
			<SubmissionOptionsModals userId={this.state.user.userId}
				onSubmissionListChanged={this.onSubmissionListChange}
				render={this.renderBody}
			/>
		);
	}

}

export default CourseRequestedSubmissions;
